import {TextField} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import {copyTextToClipboard} from "../../../other/utils/utils.jsx";

export class SwivuTextCopyField extends TextField {
  static get type() {
    return WIDGET_KEYS.fieldCopy;
  }

  static get configurable() {
    return {
      editable: false,
      triggers: {
        copyEvent: {
          cls: "fa fa-copy",
          handler: "handleCopy",
        }
      }
    }
  }

  handleCopy() {
    if (!this.parent.parent?.record?.isPhantom || !this.parent.record.isPhantom) {
      copyTextToClipboard(this.value)
    }
  }
}

SwivuTextCopyField.initClass();
